import { createContext } from 'react';
import { RuleContextProps } from './types';

export const RuleContext = createContext<RuleContextProps | undefined>(undefined);
